import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetFollowUpReportData, GetFollowUpReportEvent, GetFollowUpReportResult } from 'bloggers-backend/lib/bloggers/domain';
import { AppContext } from '../AppContext';

export function useFollowUpReport(request: GetFollowUpReportData, enabled: boolean) {
  const { client } = useContext(AppContext);

  return useQuery(
    ['followUpReport', request.granularity, request.startDate, request.endDate],
    async () => {
      const result = await client<GetFollowUpReportEvent, GetFollowUpReportResult>({
        event: 'Blogger.getFollowUpReport',
        data: request,
      });
      if (!result.success) {
        throw new Error(result.reason);
      }
      return result.value;
    },
    { enabled }
  );
}
